<template>
  <div class="error-container">
    <div class="error-content">
      <h1 class="error-code">404</h1>
      <h2 class="error-title">页面未找到</h2>
      <p class="error-description">您访问的页面不存在或已被移除</p>
    </div>
  </div>
</template>

<style scoped>
.error-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}
.error-content {
  text-align: center;
}
.error-code {
  font-size: 120px;
  font-weight: 700;
  margin: 0;
  line-height: 1;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
}
.error-title {
  font-size: 32px;
  margin: 20px 0 10px;
}
.error-description {
  font-size: 18px;
  margin-bottom: 30px;
  opacity: 0.9;
}
</style>